const buildGetDemoRequest = (action) => {
  return action;
};

const convertGetDemoResponse = (wResponse) => {
  // do some convertion and then return a new object.
  //   console.log('convertGetDemoResponse', wResponse.response);
  return wResponse.response;
};

const buildSaveDemoRequest = (data) => {
  return data;
};

export {buildGetDemoRequest, convertGetDemoResponse, buildSaveDemoRequest};
